module.exports = __webpack_public_path__ + "35483156cc9ad20d1387f5f4911df5c3.svg";